import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { MedicationSchemeResult } from 'vidis-common/medication';
import { MandatePermissions } from '../../models/enum/mandate-permissions.enum';
import { MandateService } from './../mandate/mandate.service';

@Injectable({
  providedIn: 'root'
})
export class MedicationService {

  private readonly http = inject(HttpClient);
  private readonly mandateService = inject(MandateService);

  private readonly mandatePermissions = MandatePermissions;

  getPatientMedicationScheme(ssin?: string): Observable<MedicationSchemeResult> {
    return this.mandateService.hasAccess(this.mandatePermissions.consultMedicationScheme)
      .pipe(
        switchMap(hasAccess =>
          hasAccess
            ? this.http.post<MedicationSchemeResult>('/v1/medicationscheme', {
              ssins: ssin ? [ssin] : []
            })
            : throwError(() => ({errors: [{code: 'no-access'}]}))
        ));
  }

}
